import { render } from "./Product-Card.vue?vue&type=template&id=6c59502d&scoped=true"
import script from "./Product-Card.vue?vue&type=script&lang=js"
export * from "./Product-Card.vue?vue&type=script&lang=js"

import "./Product-Card.vue?vue&type=style&index=0&id=6c59502d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c59502d"

export default script